import React, { ReactElement, useMemo } from 'react'

import { IconProps } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Flex, rem, useMantineTheme } from '@mantine/core'

type TagProps = {
  colorShade: string
  icon: ReactElement<IconProps>
  title: string
}

const Tag = ({ title, colorShade, icon }: TagProps) => {
  const theme = useMantineTheme()
  const color = useMemo(() => colorShade.split('.')[0], [])
  const shade = useMemo(() => Number(colorShade.split('.')[1]), [])
  return (
    <Flex
      align={'center'}
      gap={rem(4)}
      sx={() => ({
        border: `1px solid ${theme.colors[color][shade]}`,
        backgroundColor: theme.colors[color][shade - 1],
        borderRadius: rem(34),
        padding: ` ${rem(3)} ${rem(12)} ${rem(3)} ${rem(8)}`,
      })}
    >
      {React.cloneElement(icon, {
        size: 16,
        color: theme.colors[color][9],
      })}
      <Text size="n1">{title}</Text>
    </Flex>
  )
}

export { Tag }
